export const COLLECTION_ORDERS_TABLE_TEST_ID = 'collection-orders-table';

export const COLLECTIONS_ACCOUNTS_FILTER_TEST_ID =
  'collection-orders-accounts-filters';

export const COLLECTIONS_STATUS_FILTER_TEST_ID =
  'collection-orders-statuses-filters';

export const COLLECTIONS_FILTERS_RESET_TEST_ID = 'collection-orders-reset';

export const COLLECTION_ORDERS_DETAILS = 'collection-orders-details';

export const COLLECTION_ORDERS_EXPORT_BUTTON_TEST_ID =
  'collections_orders_export-btn';
export const COLLECTION_ORDERS_EXPORT_DIALOG_TEST_ID =
  'collections_orders_export-modal';
export const COLLECTION_ORDERS_EXPORT_DATE_RANGE_TEST_ID =
  'collections_orders_export-date-input';
export const COLLECTION_ORDERS_EXPORT_ACCOUNT_TEST_ID =
  'collections_orders_export-account-select';
export const COLLECTION_ORDERS_EXPORT_SUBMIT_TEST_ID =
  'collections_orders_export-csv-btn';
export const COLLECTION_ORDERS_EXPORT_SUCCESS_TEST_ID =
  'collections_orders_export-success-status';
